
const digest = '904e73fd9910bbd276e45c273c925630bd3710461bd9a4bbdc54b92134de4068';
const classes = {"cellWrapper":"_cellWrapper_13e09_1","text":"_text_13e09_6","textTitle":"_textTitle_13e09_13","buttonContainer":"_buttonContainer_13e09_17"};
const css = `._cellWrapper_13e09_1 {
  display: flex;
  gap: 20px;
}

._text_13e09_6 {
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 4px;
}

._textTitle_13e09_13 {
  font-weight: 500;
}

._buttonContainer_13e09_17 {
  align-self: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  